<kion-title-bar
  [project]="project"
  [title]="{ title: component.headline, titleSize: component.titleSize }"
  [description]="component.content"
></kion-title-bar>
